import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './pages/login/login.component';
import {authGuard} from './helpers/auth.guard';
import {ErrorComponent} from './pages/error/error.component';
import {TermsComponent} from './pages/terms/terms.component';
import {PrivacyPolicyComponent} from './pages/privacy-policy/privacy-policy.component';
import {HomeComponent} from './pages/home/home.component';
import {SettingsComponent} from './pages/settings/settings.component';
import {PayInvoiceComponent} from './pages/pay-invoice/pay-invoice.component';

const routes: Routes = [
  {path: '', redirectTo: 'login', pathMatch: 'full'},
  {path: 'home', component: HomeComponent},
  {path: 'login', component: LoginComponent},
  {path: 'settings', component: SettingsComponent},
  {path: 'error', component: ErrorComponent},
  {path: 'terms', component: TermsComponent},
  {path: 'privacy-policy', component: PrivacyPolicyComponent},
  {path: 'pay/invoice', component: PayInvoiceComponent},
  {
    path: 'pos',
    loadChildren: () => import('./modules/pos/pos.module').then(m => m.PosModule),
    canActivate: [authGuard],
    data: {module: 'POS_MODULE'}
  },
  {
    path: 'products',
    loadChildren: () => import('./modules/products/products.module').then(m => m.ProductsModule),
    canActivate: [authGuard],
    data: {module: 'PRODUCTS_MODULE'}
  },
  {
    path: 'users',
    loadChildren: () => import('./modules/users/users.module').then(m => m.UsersModule),
    canActivate: [authGuard],
    data: {module: 'USER_MODULE'}
  },
  {
    path: 'account',
    loadChildren: () => import('./modules/accounts/accounts.module').then(m => m.AccountsModule),
    canActivate: [authGuard],
    data: {module: 'ACCOUNTS_MODULE'}
  },
  {
    path: 'shipping',
    loadChildren: () => import('./modules/shipping/shipping.module').then(m => m.ShippingModule),
    canActivate: [authGuard],
    data: {module: 'SHIPPING_MODULE'}
  },
  {
    path: 'payments',
    loadChildren: () => import('./modules/payments/payments.module').then(m => m.PaymentsModule),
    canActivate: [authGuard],
    data: {module: 'PAYMENTS_MODULE'}
  },
  {
    path: 'refrigerator',
    loadChildren: () => import('./modules/refrigerator/refrigerator.module').then(m => m.RefrigeratorModule),
    canActivate: [authGuard],
    data: {module: 'REFRIGERATOR_MODULE'}
  },
  {
    path: 'process/flow',
    loadChildren: () => import('./modules/process-flow/process-flow.module').then(m => m.ProcessFlowModule),
    canActivate: [authGuard],
    data: {module: 'PROCESS_FLOW_MODULE'}
  },
  {
    path: 'engine',
    loadChildren: () => import('./modules/engine/engine.module').then(m => m.EngineModule),
    canActivate: [authGuard],
    data: {module: 'ENGINE_MODULE'}
  },
  {
    path: 'labour',
    loadChildren: () => import('./modules/labour/labour.module').then(m => m.LabourModule),
    canActivate: [authGuard],
    data: {module: 'LABOUR_MODULE'}
  },
  {
    path: 'credit/notes',
    loadChildren: () => import('./modules/credit-note/credit-note.module').then(m => m.CreditNoteModule),
    canActivate: [authGuard],
    data: {module: 'CREDIT_NOTE_MODULE'}
  },
  {
    path: 'stock',
    loadChildren: () => import('./modules/stock/stock.module').then(m => m.StockModule),
    canActivate: [authGuard],
    data: {module: 'STOCK_MODULE'}
  },
  {
    path: 'subscription',
    loadChildren: () => import('./modules/subscription/subscription.module').then(m => m.SubscriptionModule),
    canActivate: [authGuard],
    data: {module: 'SUBSCRIPTION_MODULE'}
  },
  {
    path: 'analytics',
    loadChildren: () => import('./modules/analytics/analytics.module').then(m => m.AnalyticsModule),
    canActivate: [authGuard],
    data: {module: 'ANALYTICS_MODULE'}
  },
  {
    path: 'logs',
    loadChildren: () => import('./modules/logging/logging.module').then(m => m.LoggingModule),
    canActivate: [authGuard],
    data: {module: 'LOGGING_MODULE'}
  },
  {
    path: 'documents',
    loadChildren: () => import('./modules/document-viewer/document-viewer.module').then(m => m.DocumentViewerModule),
    canActivate: [authGuard],
    data: {module: 'POS_MODULE'}
  },
  {
    path: 'job/status',
    loadChildren: () => import('./modules/job-status/job-status.module').then(m => m.JobStatusModule),
    canActivate: [authGuard],
    data: {module: 'JOB_STATUS_MODULE'}
  },
  {
    path: 'xero',
    loadChildren: () => import('./modules/xero/xero.module').then(m => m.XeroModule),
    canActivate: [authGuard],
    data: {module: 'XERO_MODULE', roles: ['ROLE_ADMIN', 'ROLE_ACCOUNTANT']}
  },
  {
    path: '**',
    component: ErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
